export enum surveyGames {
	Forest = 'forest',
	Scenery = 'scenery',
}

export enum standard {
	None = 'none',
}
